<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div *ngIf="!loading">
    <div class="flex-grow-1">
    <div class="row summary-row">
        <div class="col-12">
            <app-summary-totals [summaryData]="summaryData"></app-summary-totals>
        </div>
    </div>
    <div class="row flex-grow-1">
        <div id="filters" class="row pt-2">
            <div class="col-12">
                <mat-form-field appearance="fill" [hidden]="locationId || !regionList || regionList.length == 0 || selectedRegionId" style="width: 14%">
                    <mat-label>Region</mat-label>
                    <mat-select [(value)]="selectedRegionId" (selectionChange)="regionChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let region of regionList" [value]="region.id">{{region.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" [hidden]="locationId || selectedDepotId" style="width: 16%">
                    <mat-label>Depot</mat-label>
                    <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let depot of depotList" [value]="depot.id">{{depot.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" [hidden]="locationId || selectedLocationId" style="width: 26%">
                    <mat-label>Location</mat-label>
                    <mat-select [(value)]="selectedLocationId" (selectionChange)="locationChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let location of locationList" [value]="location.id">{{location.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" hidden style="width: 16%">
                    <mat-label>Show</mat-label>
                    <mat-select [(value)]="selectedShowSetting" (selectionChange)="showSettingChange($event.value)">
                        <mat-option>All</mat-option>
                        <mat-option value={{ShowSetting[ShowSetting.Surplus]}}>Surplus</mat-option>
                        <mat-option value={{ShowSetting[ShowSetting.Deficit]}}>Deficit</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" hidden style="width: 20%">
                    <mat-label>Status</mat-label>
                    <mat-select [(value)]="selectedDamageStatus" (selectionChange)="damageStatusChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.InService]}}>In Service</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.Damaged]}}>Damaged</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.DamagedInService]}}>Damaged In Service</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div id="containers" class="col-md-5 col-12 pr-1 flex-grow-1 d-flex flex-column" appSetHeight>
            <app-widget-containers [containers]="containers" [location]="location" [hidden]="!location"></app-widget-containers>
        </div>
        <div class="col-md-7 col-12 pl-1 flex-grow-1 d-flex flex-column" appSetHeight [padding]="20" [overflow]="'auto'">
        <div class="col-12 pl-0 pr-0 flex-grow-1">
            <div class="h-100 overflow-auto">
                <div class="col-12 summary pl-0">
                    <div id="report">
                        <div id="roros" *ngIf="data?.roros && data.roros.length > 0">
                            <h5>RoRo</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                <tr>
                                    <th class="group">
                                    </th>
                                    <th class="type">
                                        DEPOT
                                    </th>
                                    <th class="type">
                                        YARD
                                    </th>
                                    <th class="type">
                                        DAMAGED
                                    </th>
                                    <th class="type">
                                        AVAILABLE
                                    </th>
                                    <th class="type">
                                        USAGE
                                    </th>
                                    <th class="type">
                                        ADJUST
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                    </th>
<!--                                     <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                    </th>
                                    <th class="type">
                                        <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                    </th> -->
                                </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let group of data.roros">
                                        <tr>
                                            <td class="category">
                                                <div class="innerWrapper">
                                                    <div [hidden]="group.name == 'Total'" (click)="toggleRow(group.name + '|' + group.category)" class="controls"><i *ngIf="group.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">add</i><i *ngIf="group.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">remove</i></div>
                                                    <span class="reference">{{ group.name }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.depotCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.yardCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.damagedCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.availableCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.requiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.adjustCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.netSurplusColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                                </div> 
                                            </td>
<!--                                             <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td> -->
                                        </tr>
                                        <ng-container *ngIf="expandedCategories.includes(group.name + '|' + group.category)">
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                            <ng-container *ngFor="let assetType of group.assetTypes">
                                                <tr>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="reference">{{ assetType.name }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.depotCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.yardCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.damagedCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.availableCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.requiredCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.adjustCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netRequiredCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netSurplusCount }}</span>
                                                        </div> 
                                                    </td>
<!--                                                     <td class="default" [ngStyle]="{'color': assetType.fourWeeksTrendPercentageColor}">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.fourWeeksTrendPercentageDisplay }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default" [ngStyle]="{'color': assetType.twelveWeeksTrendPercentageColor}">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.twelveWeeksTrendPercentageDisplay }}</span>
                                                        </div> 
                                                    </td> -->
                                                </tr>
                                            </ng-container>
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div id="skips" *ngIf="data?.skips && data.skips.length > 0">
                            <h5>Skip</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                    <tr>
                                        <th class="group">
                                        </th>
                                        <th class="type">
                                            DEPOT
                                        </th>
                                        <th class="type">
                                            YARD
                                        </th>
                                        <th class="type">
                                            DAMAGED
                                        </th>
                                        <th class="type">
                                            AVAILABLE
                                        </th>
                                        <th class="type">
                                            USAGE
                                        </th>
                                        <th class="type">
                                            ADJUST
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                        </th>                                        
<!--                                         <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                        </th> -->
                                    </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let group of data.skips">
                                        <tr>
                                            <td class="category">
                                                <div class="innerWrapper">
                                                    <div [hidden]="group.name == 'Total'" (click)="toggleRow(group.name + '|' + group.category)" class="controls"><i *ngIf="group.assetTypes?.length && !expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">add</i><i *ngIf="group.assetTypes?.length && expandedCategories.includes(group.name + '|' + group.category)" class="material-icons">remove</i></div>
                                                    <span class="reference">{{ group.name }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.depotCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.yardCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.damagedCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.availableCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.requiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.adjustCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.netSurplusColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                                </div> 
                                            </td>
<!--                                             <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td> -->
                                        </tr>
                                        <ng-container *ngIf="expandedCategories.includes(group.name + '|' + group.category)">
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                            <ng-container *ngFor="let assetType of group.assetTypes">
                                                <tr>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="reference">{{ assetType.name }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.depotCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.yardCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.damagedCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.availableCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.requiredCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default">{{ assetType.adjustCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netRequiredCount }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.netSurplusCount }}</span>
                                                        </div> 
                                                    </td>
<!--                                                     <td class="default" [ngStyle]="{'color': assetType.fourWeeksTrendPercentageColor}">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.fourWeeksTrendPercentageDisplay }}</span>
                                                        </div> 
                                                    </td>
                                                    <td class="default" [ngStyle]="{'color': assetType.twelveWeeksTrendPercentageColor}">
                                                        <div class="innerWrapper">
                                                            <span class="default" *ngIf="!this.selectedDamageStatus">{{ assetType.twelveWeeksTrendPercentageDisplay }}</span>
                                                        </div> 
                                                    </td> -->
                                                </tr>
                                            </ng-container>
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div id="others" *ngIf="data?.others && data.others.length > 0" hidden>
                            <h5>Ungrouped</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                    <tr>
                                        <th class="group">
                                        </th>
                                        <th class="type">
                                            DEPOT
                                        </th>
                                        <th class="type">
                                            YARD
                                        </th>
                                        <th class="type">
                                            DAMAGED
                                        </th>
                                        <th class="type">
                                            AVAILABLE
                                        </th>
                                        <th class="type">
                                            USAGE
                                        </th>
                                        <th class="type">
                                            ADJUST
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">REQUIRED</span>
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">SURPLUS</span>
                                        </th>
<!--                                         <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">4 WEEK %</span>
                                        </th>
                                        <th class="type">
                                            <span *ngIf="!this.selectedDamageStatus">12 WEEK %</span>
                                        </th> -->
                                    </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let group of data.others">
                                        <tr>
                                            <td class="category">
                                                <div class="innerWrapper">
                                                    <span class="reference">{{ group.name }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.depotCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.yardCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.damagedCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.availableCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.requiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ group.adjustCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netRequiredCount }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.netSurplusColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.netSurplusCount }}</span>
                                                </div> 
                                            </td>
<!--                                             <td class="column" [ngStyle]="{'color': group.fourWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.fourWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td>
                                            <td class="column" [ngStyle]="{'color': group.twelveWeeksTrendPercentageColor}">
                                                <div class="innerWrapper">
                                                    <span class="default" *ngIf="!this.selectedDamageStatus">{{ group.twelveWeeksTrendPercentageDisplay }}</span>
                                                </div> 
                                            </td> -->
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div id="damage" *ngIf="damage && damage.length > 0">
                            <h5>Damage</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                <tr>
                                    <th class="container">
                                        CONTAINER
                                    </th>
                                    <th class="status">
                                        STATUS
                                    </th>
                                    <th class="status">
                                        FAULT
                                    </th>
                                    <th class="status">
                                        LOCATION
                                    </th>
                                    <th class="small" title="VOR Time">
                                        DAYS
                                    </th>
                                    <th class="small" title="Click link for details">
                                        MORE
                                    </th>
                                </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let item of damage">
                                        <tr>
                                            <td class="container" title="{{ item.assetId }}">
                                                <div class="innerWrapper">
                                                    <div (click)="toggleDamage(item.id)" class="controls"><i *ngIf="!expandedDamage.includes(item.id)" class="material-icons">add</i><i *ngIf="expandedDamage.includes(item.id)" class="material-icons">remove</i></div>
                                                    <span class="reference">{{ item.assetId }}</span>
                                                </div> 
                                            </td>
                                            <td class="status" title="{{ item.statusDescription }}">
                                                <div class="innerWrapper">
                                                    <span class="default">{{item.statusDescription }}</span>
                                                </div> 
                                            </td>
                                            <td class="status" title="{{ item.faultDescription }}">
                                                <div class="innerWrapper">
                                                    <span class="default">{{item.faultDescription }}</span>
                                                </div> 
                                            </td>
                                            <td class="email" title="{{ item.currentLocation }}">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ item.currentLocation }}</span>
                                                </div> 
                                            </td>
                                            <td class="small">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ item.numberOfDays }}</span>
                                                </div> 
                                            </td>
                                            <td class="small">
                                                <div class="innerWrapper">
                                                    <a href="/damage/{{item.assetId}}" target="_blank">⧉</a>
                                                </div> 
                                            </td>
                                        </tr>
                                        <ng-container *ngIf="expandedDamage.includes(item.id)">
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                            <tr>
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="reference">Reported:</span>
                                                    </div> 
                                                </td>
                                                <td class="container">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ item.reportedDisplayDate }}</span>
                                                    </div> 
                                                </td>
                                            </tr>
                                            <tr [hidden]="!item.sentForRepairDisplayDate">
                                                <td class="default">
                                                    <div class="innerWrapper">
                                                        <span class="reference">Assessed:</span>
                                                    </div> 
                                                </td>
                                                <td class="container">
                                                    <div class="innerWrapper">
                                                        <span class="default">{{ item.sentForRepairDisplayDate }}</span>
                                                    </div> 
                                                </td>
                                            </tr>
                                            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                                        </ng-container>                                        
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
        </div>
        </div>
    </div>
    </div>
</div>